module.exports = __webpack_public_path__ + "img/shield-fill-plus.f072ff34.svg";